import { render } from "./MedicationForm.vue?vue&type=template&id=b2368a5a"
import script from "./MedicationForm.vue?vue&type=script&lang=js"
export * from "./MedicationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__